// Last-Seen-API für den Markt-Hero (alle User). Der Aufruf rotiert serverseitig
// current→prev und setzt current=jetzt; zurück kommt der VORHERIGE Besuch.
import { apiFetch } from './api';

export interface LastSeenResponse {
  current_at: string;
  prev_at: string | null;
}

export async function pingLastSeen(accessToken: string): Promise<LastSeenResponse> {
  return apiFetch<LastSeenResponse>('/eve/last-seen', { method: 'GET', accessToken });
}
